import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import GradingTypeForm from '../../../components/forms/GradingTypeForm';
import { useGradingTypeApi } from '../../../hooks/useGradingTypeApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { GradingTypeDTO } from '../../../services/apiClient';

const GradingTypeCreate: React.FC = () => {
  const { create, isLoading } = useGradingTypeApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Grading Types', href: '/admin/gradingtypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: GradingTypeDTO) => {
    try {
      await create(data);
      navigate('/admin/gradingtypes');
    } catch (error) {
      console.error('Error creating Grading Type:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/gradingtypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.GradingType.Edit'
    >
        <GradingTypeForm
          initialValues={{} as GradingTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/gradingtypes')}
        />
    </AdminLayout>
  );
};

export default GradingTypeCreate;